import { EventEmitter, Injectable, Output, Directive } from '@angular/core';
import { StorageService } from '@shared/services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

@Directive()
@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  currentLang: string = null;
  public languageEmitter: any = new Subject<string>();
  @Output() langChangeEmitter: EventEmitter<string> = new EventEmitter();

  constructor(
    public storage: StorageService,
    public translate: TranslateService,
    private route: Router,
    private aR: ActivatedRoute
  ) {
    translate.addLangs([
      'en',
      'pl',
      'es',
      'pt',
      'fr',
      'uk',
      'de',
      'sk',
      'ro',
      'cz',
      'id',
      'ms',
      'it',
      'tr',
    ]);
    translate.setDefaultLang('en');
  }

  init() {
    console.log(document.referrer);
    if (!this.storage.get('lang')) {
      this.updateCurrentLang(this.correctNavigationLang());
    } else {
      this.translate.use(this.storage.get('lang'));
    }
  }

  getCurrentLang() {
    let lang = this.correctNavigationLang();
    return lang.toLocaleLowerCase();
  }

  correctNavigationLang(): string {
    const origin = document.referrer;
    const frameRef = window.frames.top.document.referrer;
    console.log('what i have:', origin, frameRef);
    if (origin.includes('herotohero.eu')) {
      const searchedLang = origin.split('.');
      const lang = searchedLang[1].slice(3, 5);
      return lang ? lang : 'pl';
    } else if (origin.includes('.de')) {
      return 'de';
    }
    return this.getPossibleBrowserLang();
  }

  getPossibleBrowserLang(): string {
    let res = navigator.language;
    const resSplitFloor = res.split('_');
    const resSplitDash = res.split('-');

    if (resSplitFloor.length > 1) {
      res = resSplitFloor[0];
    }
    if (resSplitDash.length > 1) {
      res = resSplitDash[0];
    }
    res = this.translate.getLangs().indexOf(res) > -1 ? res : 'en';
    return res.toLowerCase();
  }

  updateCurrentLang(newLang?: string) {
    var lang = newLang ?? this.getPossibleBrowserLang();
    this.currentLang = lang.toLowerCase();
    this.storage.put('lang', this.currentLang);
    this.translate.use(this.currentLang);
    this.languageEmitter.next(this.currentLang);
    this.langChangeEmitter.emit(this.currentLang);
  }
}
